<div class="w-full max-w-4xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
        <h2>XML Villuprófun</h2>
        <div class="flex flex-col gap-4 mt-4 sm:mt-0 md:mt-4 w-full">
            <p class="m-0">
                Hér er hægt að setja inn XML skrá og XSD skrá til þess að villuprófa XML skrána.<br />
                Niðurstöður úr villuprófuninni birtast hér að neðan, ef að einhverjar villur fundust þá eru þær listaðar upp í töflu.
            </p>
        </div>
    </div>
    <div class="flex flex-col gap-4">
        <div class="flex flex-col sm:flex-row gap-4">
            <div class="flex flex-col grow">
                <div class="prose prose-sm mb-2">
                    <h3>XML skrá</h3>
                </div>
                <ng-container>
                    <ngx-dropzone [multiple]="false" class="justify-center" (change)="onSelectXMLFile($event)">
                        <ngx-dropzone-label>
                            <div>
                                <h2>Veldu eða dragðu inn skjal</h2>
                                <mat-icon class="mt-1 icon-size-7" svgIcon="feather:file"></mat-icon>
                            </div>
                        </ngx-dropzone-label>
                        @if (xmlFile) {
                            <ngx-dropzone-preview [removable]="true" (removed)="onRemoveXMLFile()">
                                <ngx-dropzone-label>{{ xmlFile.name }}</ngx-dropzone-label>
                            </ngx-dropzone-preview>
                        }
                    </ngx-dropzone>
                </ng-container>
            </div>
            <div class="flex flex-col grow">
                <div class="prose prose-sm mb-2">
                    <h3>XSD skrá</h3>
                </div>
                <ng-container>
                    <ngx-dropzone [multiple]="false" class="justify-center" (change)="onSelectSchemaFile($event)">
                        <ngx-dropzone-label>
                            <div>
                                <h2>Veldu eða dragðu inn skjal</h2>
                                <mat-icon class="mt-1 icon-size-7" svgIcon="feather:file"></mat-icon>
                            </div>
                        </ngx-dropzone-label>
                        @if (schemaFile) {
                            <ngx-dropzone-preview [removable]="true" (removed)="onRemoveSchemaFile()">
                                <ngx-dropzone-label>{{ schemaFile.name }}</ngx-dropzone-label>
                            </ngx-dropzone-preview>
                        }
                    </ngx-dropzone>
                </ng-container>
            </div>
        </div>
        <div class="flex justify-end gap-4">
            <button
                class="w-fit"
                mat-flat-button
                type="button"
                [color]="'primary'"
                (click)="validateXML()"
                [disabled]="!xmlFile || !schemaFile"
            >
                <mat-icon class="icon-size-5 mr-1" fontIcon="download" matPrefix></mat-icon>
                Villuprófa
            </button>
        </div>
    </div>
    @if (result) {
        <hr />
    }
    @if (result) {
        <div class="mb-2">
            <div class="prose prose-sm flex items-center">
                <h3 class="m-0">Niðurstaða:</h3>
                @if (result.isValid) {
                    <mat-icon
                        class="icon-size-10 text-green-500 dark:text-green-400"
                        [svgIcon]="'heroicons_outline:check-circle'"
                    ></mat-icon>
                }
                @if (!result.isValid) {
                    <mat-icon class="icon-size-10 text-red-500 dark:text-red-400" [svgIcon]="'heroicons_outline:x-circle'"></mat-icon>
                }
            </div>
            @if (result.isValid) {
                <div>
                    <div class="prose prose-sm mb-2 flex items-center">
                        <p class="m-0">Engar villur fundust</p>
                    </div>
                </div>
            }
            @if (!result.isValid) {
                <div>
                    <div class="prose prose-sm mb-2 flex items-center">
                        <p>Eftirfarandi villur fundust:</p>
                    </div>
                    <div class="mat-table-wrapper grid h-fit overflow-x-auto">
                        <table matSort mat-table [dataSource]="errorData" class="w-full">
                            <ng-container matColumnDef="lineNumber">
                                <th mat-sort-header="lineNumber" mat-header-cell *matHeaderCellDef>Línunúmer</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.lineNumber }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="message">
                                <th mat-header-cell *matHeaderCellDef>Villuskilaboð</th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.message }}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="errorTableColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: errorTableColumns"></tr>
                        </table>
                    </div>
                </div>
            }
        </div>
    }
</div>
